"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BankAccountStatus = void 0;

var common_1 = require("./common");

var BankAccountStatus;

(function (BankAccountStatus) {
  BankAccountStatus["PENDING"] = "pending";
  BankAccountStatus["VERIFIED"] = "verified";
  BankAccountStatus["DISABLED"] = "disabled";
  BankAccountStatus["MANUAL_CHECK"] = "manual check required";
  BankAccountStatus["CONSENT_EXPIRED"] = "consent_expired";
})(BankAccountStatus = exports.BankAccountStatus || (exports.BankAccountStatus = {}));